import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  TextField,
  Divider,
} from "@mui/material";
import Header from "../components/Header";
import { isLoggedIn } from "../utils/authHelper";

import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const loggedIn = isLoggedIn();

  useEffect(() => {
    if (loggedIn) {
      const user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {};
      if (user?.role == "admin" || user?.role == "manager") {
        navigate("/admin/home");
      } else {
        navigate("/teacher/home");
      }
    }
  }, []);

  const goToLoginPage = () => {
    navigate("/login");
  };

  const goToEnquiryForm = () => {
    navigate("/enquiry/form");
  };

  return (
    <div>
      <Header />

      {/* Main Content */}
      <Container sx={{ marginTop: 4 }}>
        {/* Conditional Display Based on Login State */}
        {!loggedIn && (
          <Box className="bg-gray-100 p-4 rounded shadow">
            <Typography variant="h5" className="text-blue-900">
              Welcome to JASS Admissions
            </Typography>
            <Typography variant="body1" className="text-gray-700">
              Fill out the form to express interest in joining JASS Group of
              Schools.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body1" className="text-gray-700">
              Are you a parent or guardian looking to enroll your child?
            </Typography>
            <Button
              variant="contained"
              className="bg-blue-500 text-white mt-16"
              sx={{ mt: 2, fontWeight: "bold", fontSize: 16 }}
              onClick={goToEnquiryForm}
            >
              Fill Form as Parent
            </Button>
            <Typography
              variant="body1"
              className="text-gray-700"
              sx={{ mt: 2 }}
            >
              OR
            </Typography>
            <Typography
              variant="body1"
              className="text-gray-700"
              sx={{ mt: 2 }}
            >
              Are you are staff from JASS group?
            </Typography>
            <Button
              variant="contained"
              className="bg-blue-500 text-white mt-16"
              sx={{ mt: 2, fontWeight: "bold", fontSize: 16 }}
              onClick={goToLoginPage}
            >
              Login (for Staff)
            </Button>
          </Box>
        )}
      </Container>
    </div>
  );
};

export default HomePage;
